import React from 'react';
// Import icons (requires: npm install react-icons)
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';

// NOTE: For the unique social button style, a custom CSS class is needed (see Section 3).
const SocialIconBox = ({ href, ariaLabel, Icon }) => (
  <a 
    href={href} 
    aria-label={ariaLabel} 
    // Applying custom class for the dark neomorphic look
    className="social-icon-box flex items-center justify-center w-10 h-10 rounded-md transition duration-300"
  >
    <Icon className="text-white text-base" />
  </a>
);

const Footer = () => {
  return (
    <footer className="bg-black text-white px-8 lg:px-16 pt-4">
      {/* 1. Header Section */}
      <div className="border-b border-gray-700 pb-2 mb-4">
       
      </div>

      {/* 2. Main Content: Logo/Nav and Social Icons */}
      <div className="flex justify-between items-center pb-4">
        
        {/* Logo and Navigation */}
        <div className="flex items-center space-x-16">
          {/* Logo */}
          <div className="flex items-center">
            <span className="text-xl font-extrabold mr-2">~~</span>
            <span className="text-base font-bold cursor-pointer">ezeeta</span>
          </div>

          {/* Navigation Links */}
          <nav className="hidden md:flex space-x-5 text-sm">
            {['Home', 'Project', 'About', 'Contact'].map((item) => (
              <a 
                key={item} 
                href={`/${item.toLowerCase().replace(' ', '-')}`} 
                className="hover:text-gray-400"
              >
                {item}
              </a>
            ))}
          </nav>
        </div>
        
        {/* Social Media Icons */}
        <div className="flex space-x-3">
          <SocialIconBox href="https://facebook.com" ariaLabel="Facebook" Icon={FaFacebookF} />
          <SocialIconBox href="https://twitter.com" ariaLabel="Twitter" Icon={FaTwitter} />
          <SocialIconBox href="https://linkedin.com" ariaLabel="LinkedIn" Icon={FaLinkedinIn} />
        </div>
      </div>
      
      {/* 3. Contact Info and Legal Links Row */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center py-5 border-t border-gray-800">
        
        {/* Contact Information */}
        <div className="flex flex-col md:flex-row space-y-3 md:space-y-0 md:space-x-8 text-sm">
          {/* Email */}
          <div className="flex items-center">
            <FaEnvelope className="mr-2 text-white" />
            <a href="mailto:contact@catalystanalytics.io" className="hover:text-gray-400">adeele358@gmail.com</a>
          </div>
          {/* Phone */}
          <div className="flex items-center">
            <FaPhone className="mr-2 text-white" />
            <a href="tel:+14697124672" className="hover:text-gray-400">+923073040088</a>
          </div>
          {/* Address */}
          <div className="flex items-center">
            <FaMapMarkerAlt className="mr-2 text-white" />
            <span>University of Okara</span>
          </div>
        </div>
        
        {/* Legal Links */}
        <div className="flex space-x-5 mt-4 md:mt-0 text-sm">
          <a href="/privacy-policy" className="hover:text-gray-400">Privacy Policy</a>
          <a href="/terms-of-service" className="hover:text-gray-400">Terms of Service</a>
        </div>
      </div>

      {/* 4. Copyright Section */}
      <div className="text-center py-4 text-xs text-gray-400 border-t border-gray-800">
        <p>© 2025 ezeeta. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;